<template>
  <b-toast title="Atención" :visible="active" ok-only @ok="closeModal" :variant="type">
    {{ message }}
  </b-toast>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useFlashStore } from "@/stores/FlashStore";

export default {
  computed: mapState(useFlashStore, ["active", "message", "type"]),
  methods: {
    ...mapActions(useFlashStore, ["clearFlash"]),
    closeModal(event) {
      event.preventDefault();
      if (this.type == "SessionNotFound") {
        this.clearFlash();
        this.$router.push("/login");
      } else {
        this.clearFlash();
      }
    },
  },
};
</script>
